<template>
  <div  >
    <v-dialog  v-model="dialogUp"   v-if="dialogUp" fullscreen persistent class="sensor-dialog" transition="dialog-bottom-transition">
      <SensorDetails v-if="selectedDevice != ''" :show.sync="dialogUp" :id="selectedDevice"> </SensorDetails>
    </v-dialog>
    <!-- <Table></Table> -->
    <server-table-component style="width: 100%;"
      simple
      server="login"
      :rowProp="rows"
      schema="sch_sensors"
      :editable="false"
    ></server-table-component>
  </div>
</template>

<script>
// import axios from 'axios'
import axiosInstances from '@/../../coreui/server/axiosInstances'
import { sync } from 'vuex-pathify'
import ui from '@/../../coreui/helpers/ui'
// import Table from '@/library/TemplateTable'
// import Picker from '@/library/Picker'
import SensorDetails from './SensorDetails'
// import utils from '@/../../coreui/helpers/utils'
export default {
  components: {
    // Table,
    SensorDetails
  },
  data: () => ({
    sch: {},
    headers: [],
    intervalId: 0,
    selectedDevice: '',
    hBack: [],
    rBack: [],
    rows: [],
    intvlChange: false,
    dialogUp: false
  }),
  computed: {
    loggedinOrg: sync('login/loggedinOrg'),
    rowClickFunction: sync("table/tableRowClickFunction"),
    orgSensors:sync('table/orgSensors')
  },
  watch: {
    intvlChange(val) {
      this.getValues()
    },
    dialogUp(val, old) {

    }
  },
  methods: {
    async getValues() {
      var self = this
      var k
      var sensors = await axiosInstances.loginServer.get('dt/v1/auth_provisions?org='+this.loggedinOrg['name'])
      // console.log('SENSORS:' ,sensors)
      var dictionary = await axiosInstances.loginServer.get('dt/v1/dictionary')
      // console.log('dictionary: ', dictionary)
      sensors.data.forEach(async function(item) {
        if (item.type !== 'sensor' ) return // || item.show == 'no'
        var labels = []
        k = await axiosInstances.apiServer.get('/dt/v1/' + item.deviceID + '?last=1')
        if (!k.data) return
        let keys = Object.keys(k.data[0].data)
        console.log(k)
        var updated = k.data[0].ts
        console.log('last = ', updated, k.data[0])
        labels = keys.map(function(k) {
          let idx = dictionary.data.findIndex(p => p.code == k)
          if (dictionary.data[idx] == undefined) {
            console.log(k)
          }
          return dictionary.data[idx].label
        })
        var newval = []
        keys.forEach(function(key) {
          newval.push(k.data[0].data[key])
        })
        let idx = self.rows.findIndex(p => p.deviceid == item.deviceID)
        console.log(idx, item.deviceID)
        if (idx == -1) {
          console.log('last: ', updated)
          self.rows.push(
            {
              deviceid: item.deviceID,
              deviceName: item.deviceName,
              location: item.location,
              updated: updated,
              sensors: keys,
              labels: labels.join(', '),
              value: newval
            }
          )
        } else {
          self.$set(self.rows[idx], 'value', newval)
          self.$set(self.rows[idx], 'updated', updated)
          // self.rows[idx].value = newval
        } 
      })
    },
    initialize () {
      this.rows = []
      var self = this
      this.moreClickFunction = function (item) {
        self.selectedDevice = item.deviceid
        self.dialogUp = true
      }
      this.getValues()
      // console.log('ROWS: ',this.rows)
    },
  },
  mounted () {
    this.initialize()
    var self = this
    this.intervalId = setInterval(function() {
      self.intvlChange = !self.intvlChange
    }, 60000)
    this.rowClickFunction = function (val) {
      self.selectedDevice = val.deviceid
      self.dialogUp = true
    }
  },
  created () {
    
  },
  beforeDestroy() {
    // this.showEditButtons = true
    // this.showDeleteButtons = true
    // this.showAddButton = true
    clearInterval(this.intervalId)
    this.rowClickFunction = null
  }
}
</script>

<style >
.v-dialog--fullscreen {
  width: 100% !important;
  height: 100% !important;
}
</style>
